export default value => () => value
